export const BASE_URL =
  ((window as any).env && (window as any).env.baseHost) || ''

export const endpoints = {
  products: (
    productId: number
  ) =>
    `${BASE_URL}/api/v3/crosses/${productId}/products`
}
